import {Pressable, StyleSheet, Text} from 'react-native';
import {Color} from "@/lib/styles";
import {Href, useRouter} from "expo-router";
import Icon, {IconKind} from "@/lib/components/Icon";
import {useState} from "react";

type Props = {
    title?: string,
    color?: string,
    iconColor?: string,
    icon?: IconKind,
    dashed?: boolean,
    href: Href,
}

export default function NavButton({title, icon, color, href, dashed, iconColor}: Props) {
    const router = useRouter();
    const [hover, setHover] = useState(false);

    const themed_color = color ? color : Color.PrimaryText;
    const icon_color = iconColor ? iconColor : Color.PrimaryText;
    const iconSize = 16;

    return (
        <Pressable onPress={() => router.push(href)}
                   onHoverIn={() => setHover(true)}
                   onHoverOut={() => setHover(false)}
                   style={[
                       styles.container,
                       {
                           borderColor: themed_color,
                           outlineColor: themed_color,
                           outlineWidth: hover ? 1 : 0,
                       },
                       dashed ? {borderStyle: "dashed"} : {},
                   ]}
        >
            {icon && <Icon kind={icon} size={iconSize} color={icon_color}/>}
            {title && <Text style={[styles.buttonLabel, {color: themed_color}]}>{title}</Text>}
        </Pressable>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        paddingHorizontal: 12,
        gap: 6,
        height: 42,
        borderRadius: 8,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: Color.PrimaryText,
        backgroundColor: "transparent",
        outlineStyle: "solid",
    },
    buttonLabel: {
        color: Color.PrimaryText,
        fontSize: 16,
        lineHeight: 16,
    },
});